import * as actions from './actions';

export const setDevice = (device) => ({
    type: actions.SET_DEVICE,
    device,
});

export const setVersion = (version) => ({
    type: actions.SET_VERSION,
    version,
});

export const setRedirectPath = (path) => ({
    type: actions.SET_REDIRECT_PATH,
    path,
});


// WEBPACK FOOTER //
// ./src/redux_related/ui/actionCreators.js